import * as React from 'react';
import { Box, TextInput, Group, Button, NumberInput } from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import { DatePicker } from "@mantine/dates";
import type { IBanner } from "./types";
import { IMAGE_MIME_TYPE } from "@mantine/dropzone";
import FileUpload from "../../components/file-upload";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";
import { assignFiles } from "../../utils/form";

interface FormValues extends Pick<IBanner, 'title' | 'link' | 'order'> {
    image: File | null;
    mobileImage: File | null;
    startDate: Date;
    endDate: Date;
}

interface IParams extends Omit<FormValues, 'image' | 'mobileImage'> {
    image?: string;
    mobileImage?: string;
}

const CreateBanner = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            title: '',
            image: null,
            mobileImage: null,
            link: '',
            order: 0,
            startDate: new Date(),
            endDate: new Date(),
        },

        validate: {
            title: isNotEmpty('Нэр оруулна уу'),
            image: isNotEmpty('Таблетны зураг оруулна уу'),
            mobileImage: isNotEmpty('Утасны зураг оруулна уу'),
            startDate: isNotEmpty('Эхлэх огноо оруулна уу'),
            endDate: isNotEmpty('Дуусах огноо оруулна уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const files = await assignFiles({
            image: values.image,
            mobileImage: values.mobileImage
        }, 'banner')
        const params: IParams = {
            ...values,
            ...files
        }
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, params);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Нэр"
                            placeholder="Нэр оруулна уу"
                            {...form.getInputProps('title')}
                        />

                        <FileUpload
                            value={form.values.image}
                            onChange={(value) => {
                                form.setFieldValue('image', value);
                            }}
                            label='Таблетны зураг (1:1.3)'
                            accept={IMAGE_MIME_TYPE}
                            ratio={'1/1.3'}
                        />

                        <FileUpload
                            value={form.values.mobileImage}
                            onChange={(value) => {
                                form.setFieldValue('mobileImage', value);
                            }}
                            label='Утасны зураг (2:1)'
                            accept={IMAGE_MIME_TYPE}
                            ratio={'2/1'}
                        />

                        <DatePicker
                            withAsterisk
                            placeholder="Эхлэх огноо"
                            label="Эхлэх огноо"
                            {...form.getInputProps('startDate')}
                        />

                        <DatePicker
                            withAsterisk
                            placeholder="Дуусах огноо"
                            label="Дуусах огноо"
                            {...form.getInputProps('endDate')}
                        />

                        <TextInput
                            label="Холбоос"
                            placeholder="Холбоос оруулна уу"
                            {...form.getInputProps('link')}
                        />

                        <NumberInput
                            label="Дараалал"
                            placeholder="Дараалал"
                            {...form.getInputProps('order')}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default CreateBanner;